import React, { JSX } from 'react';
import { Text, Field, LinkField, Link } from '@sitecore-jss/sitecore-jss-nextjs';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import { StyleguideComponentProps } from 'lib/component-props';

type SpotlightGradientProps = StyleguideComponentProps & {
    fields: {
        MarginSize: {
            fields: {
                heading: {
                    value: string;
                };
            };
        };
        Headline: Field<string>;
        CTA: LinkField;
    };
};

const SpotlightGradient = (props: SpotlightGradientProps): JSX.Element => {
    if (!props || !props.fields) {
        return <div></div>;
    }
    const marginSize = getMarginSize(props?.fields?.MarginSize?.fields?.heading?.value);

    return (
        <div
            className={classNames('overhauled', marginSize)}
            key={`spotlight-gradient-${props.rendering.uid}`}
            id={`spotlight-gradient-${props.rendering.uid}`}
        >
            <div className="spotlight gradient">
                <div className="jss-inner-container content-wrapper">
                    <div className="text-wrapper">
                        {props.fields?.Headline?.value && (
                            <Text
                                tag="h2"
                                className="osf-display-h2 headline"
                                field={props.fields.Headline}
                            />
                        )}
                    </div>
                    {props.fields?.CTA?.value?.href && (
                        <Link
                            field={props.fields.CTA}
                            className="btn-mobile-fw btn-secondary"
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default SpotlightGradient;